import { AxiosInstance, AxiosResponse } from 'axios';

import type { TypedApiMethods } from './apiTypes';

export interface Response<T> extends AxiosResponse<T> {}

// Import the actual axios instance
import { axiosInstance as apiInstance, mock as mockInstance } from './api';

// Export with type that preserves AxiosInstance for mocking compatibility
// TypeScript will see both AxiosInstance methods and our typed overloads
// @ts-ignore - Intentionally using intersection type for mock compatibility
export const api: TypedApiMethods & AxiosInstance = apiInstance;
export const mock = mockInstance;
